import { useParams } from 'react-router-dom';
import { Layout } from '../../../components';

const BankIdSignSaveDocument = () => {
    const params = useParams();
    console.log('params', params);
    return <Layout>BankId sign save document</Layout>;
};

export default BankIdSignSaveDocument;
